import { CartViewEvent } from "./analytics.types";
import { getCartStore, getOrderStore } from "../utils";
import { ProductData } from "../commerce/cart.types";

export class AnalyticsStore {
    constructor(
        private dataLayer? : object[],
        private plausible?: (event: string, props?: Record<string, any>) => void
    ) {
        window.addEventListener("cart-item-added", (_: Event) => {
            this.trackCartItemAdded();
        });
        window.addEventListener("cart-item-removed", (_: Event) => {
            this.trackCartItemRemoved();
        });
        window.addEventListener("cart-viewed", (event: Event) => {
            const e = (event as CustomEvent<CartViewEvent>).detail;
            if(e.userInitiated) {
                this.trackUserCartViewed();
            }else {
                this.trackAutoCartViewed();
            }
        });
    }
    initialize(): void {
        this.dataLayer = window.dataLayer;
        this.plausible = window.plausible;
    }

    public trackUserCartViewed() {
        console.debug("Tracking user cart viewed");
        const cart = getCartStore();
        if(this.dataLayer) {
            this.dataLayer.push({ecommerce:null});
            this.dataLayer.push({
                event: "view_cart",
                ecommerce:{
                    currency: getOrderStore().currencyCode,
                    value: Number(cart.subtotal?.withoutTax),
                    items: cart.items.map((item, index) => ({
                        item_id: item.sku,
                        item_name: item.name,
                        discount: item.unitPrice.adjustment.withoutTax * -1,
                        price: item.unitPrice.value.withoutTax,
                        quantity: item.quantity,
                        index: index,
                    }))
                }
            })
        }

        if (this.plausible != null) {
            this.plausible("View Cart");
        }
    }
    public trackAutoCartViewed() {
        console.debug("Tracking auto cart viewed");
        const cart = getCartStore();
        if(this.dataLayer) {
            this.dataLayer.push({ecommerce:null});
            this.dataLayer.push({
                event: "view_cart_auto",
                ecommerce:{
                    currency: getOrderStore().currencyCode,
                    value: Number(cart.subtotal?.withoutTax),
                    items: cart.items.map((item, index) => ({
                        item_id: item.sku,
                        item_name: item.name,
                        discount: item.unitPrice.adjustment.withoutTax * -1,
                        price: item.unitPrice.value.withoutTax,
                        quantity: item.quantity,
                        index: index,
                    }))
                }
            })
        }
    }

    public trackCartItemAdded() {
        const cart = getCartStore();
        console.debug("Tracking cart item added");
        if (this.dataLayer) {
            this.dataLayer.push({ecommerce:null});
            this.dataLayer.push({
                event: "add_to_cart",
                ecommerce:{
                    currency: getOrderStore().currencyCode,
                    value: Number(cart.subtotal?.withoutTax),
                    items: cart.items.map((item, index) => ({
                        item_id: item.sku,
                        item_name: item.name,
                        discount: item.unitPrice.adjustment.withoutTax * -1,
                        price: item.unitPrice.value.withoutTax,
                        quantity: item.quantity,
                        index: index,
                    }))
                }
            })
        }

        if (this.plausible != null) {
            this.plausible("Add To Cart");
        }
    }
    public trackCartItemRemoved() {
        console.debug("Tracking cart item removed");
        const cart = getCartStore();
        if (this.dataLayer) {
            this.dataLayer.push({ecommerce:null});
            this.dataLayer.push({
                event: "remove_from_cart",
                ecommerce:{
                    currency: getOrderStore().currencyCode,
                    value: Number(cart.subtotal?.withoutTax),
                    items: cart.items.map((item, index) => ({
                        item_id: item.sku,
                        item_name: item.name,
                        discount: item.unitPrice.adjustment.withoutTax * -1,
                        price: item.unitPrice.value.withoutTax,
                        quantity: item.quantity,
                        index: index,
                    }))
                }
            })
        }

        if (this.plausible != null) {
            this.plausible("Remove From Cart");
        }
    }
    public trackItemViewed(product: ProductData) {
        console.debug("Tracking cart item viewed");
        const price = (product.offerPrices && product.offerPrices.length > 0) ? product.offerPrices[0].offerPrice.withoutTax : product.price.withoutTax;

        if (this.dataLayer) {
            this.dataLayer.push({ecommerce:null});
            this.dataLayer.push({
                event: "view_item",
                ecommerce:{
                    currency: getOrderStore().currencyCode,
                    value: price,
                    items: [product].map((item) => ({
                        item_id: item.sku,
                        item_name: item.name,
                        price: item.price.withoutTax,
                        quantity: item.quantity,
                        index: 0,
                    }))
                }
            })
        }
    }
}